import I from "../../../../node_modules/lodash/isNumber.js";
import g from "../../../../node_modules/lodash/gt.js";
import e from "../../../../node_modules/lodash/isUndefined.js";
import C from "../../../../node_modules/lodash/isNull.js";
import { Control as u, Option as a, SingleValue as S, ClearIndicator as l, DropdownIndicator as p, IndicatorsContainer as V, Menu as f, MenuList as d, SelectInput as h, NoOptionsMessage as N, Placeholder as m, MultiValue as M, Input as L } from "./controls.helper.js";
const D = {
  Control: u,
  Option: a,
  SingleValue: S,
  IndicatorSeparator: () => null,
  ClearIndicator: l,
  DropdownIndicator: p,
  IndicatorsContainer: V,
  Menu: f,
  MenuList: d,
  Input: h,
  NoOptionsMessage: N,
  Placeholder: m
}, F = {
  Control: u,
  MultiValue: M,
  Input: L,
  Option: a,
  MultiValueRemove: () => null,
  ClearIndicator: l,
  DropdownIndicator: p,
  Menu: f,
  MenuList: d,
  IndicatorSeparator: () => null,
  NoOptionsMessage: N,
  Placeholder: m
}, s = (t) => {
  if (e(t) || C(t)) return NaN;
  if (t === "auto") return NaN;
  if (I(t)) return t;
  const n = t == null ? void 0 : t.match(/^(\d*\.?\d+)(%)?$/);
  if (!n) return NaN;
  const r = parseFloat(n[1]);
  return n[2] === "%" ? r * 16 : NaN;
}, c = (t, n) => {
  const r = s(t), o = s(n);
  return isNaN(r) || isNaN(o) ? !1 : g(r, o);
}, U = (t, n) => e(n) ? e(t) ? "100%" : t : c("100%", t) ? c(t, n) ? t : n : "100%", $ = (t) => {
  if (t.current) {
    const { left: n, width: r } = t.current.getBoundingClientRect(), i = window.innerWidth - n - r, w = n;
    return i < r && w > i;
  }
};
export {
  F as MultiSelectComponents,
  D as SelectComponents,
  c as compareValues,
  U as handleMenuWidth,
  $ as handlePosition
};
//# sourceMappingURL=helper.js.map
